import { Heading } from 'blaze-ui/Heading/Heading'
import Styles from './Access.module.scss'

import useShareSheetV2 from 'hooks/useShareSheetV2'
import { ShareSheetScreen, useShareSheetContext } from '../ShareSheetV2'
import { AccessListWithButton } from './AccessListWithButton'
import { Button } from 'blaze-ui/Button'
import { Approval } from 'blaze-ui/icons/20'
import { ActiveSettingsMember, RecipientsSelectorValueType } from 'types'
import { uniqBy } from 'lodash'
import { useAuth } from 'hooks/UseAuth'
import { InformalFeedbackRequest } from 'api/clients/InformalFeedbackRequestsClient'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'
import { Text } from 'blaze-ui/Text/Text'
import { useAutopilotUpgradeGuard } from 'hooks/useAutopilotUpgradeGuard'

export const Access = ({ request }: { request?: InformalFeedbackRequest }) => {
  const { setScreen, file } = useShareSheetContext()
  const { invitedAccesses, setShareSheet, inheritedAccesses } = useShareSheetV2(file)
  const auth = useAuth()

  const accesses = uniqBy([...invitedAccesses, ...inheritedAccesses], 'id').filter(
    (access) => access.accessor.id !== auth?.id,
  )

  const handleEveryone = () => {
    setShareSheet({
      recipients: accesses.map((access) => {
        return {
          type: RecipientsSelectorValueType.User,
          value: {
            ...access.accessor,
            first_name: access.accessor.name.split(' ')?.[0],
            last_name: access.accessor.name.split(' ')?.[1],
            display_name: access.accessor.name,
            role: 'User',
            created_at: new Date(),
            confirmed_at: new Date(),
            last_activity_at: new Date(),
          } as ActiveSettingsMember,
        }
      }),
      reviewScreenTitle: 'Ask Everyone with Access to Review',
    })
    setScreen(ShareSheetScreen.InviteAccess)
  }

  const guardedAutopilotUpgradePress = useAutopilotUpgradeGuard(() => {
    setScreen(ShareSheetScreen.EditAccess)
  })

  return (
    <div className={Styles.container}>
      <div className={Styles.peopleWithAccess}>
        <div className={Styles.header}>
          <ResponsiveDesign.Desktop>
            <Heading level={5}>People with access</Heading>
          </ResponsiveDesign.Desktop>
          <ResponsiveDesign.Mobile>
            <Text variant="smallList" color="var(--dark-80)">
              People with access
            </Text>
          </ResponsiveDesign.Mobile>
          <Button variant="secondary" size="md" onPress={guardedAutopilotUpgradePress}>
            Edit Access
          </Button>
        </div>
        <AccessListWithButton accesses={accesses} request={request} />
        {!request && accesses.length > 0 && (
          <div>
            <Button frontIcon={Approval} variant="secondary" onPress={handleEveryone} size="md">
              Ask Everyone with Access to Review
            </Button>
          </div>
        )}
      </div>
    </div>
  )
}
